module.exports = __webpack_public_path__ + "static/img/puji11.6fb43829.png";